import { ExternalLink } from '@uikit/components/ExternalLink';

export const gallery = [
  {
    image: '/launchpad/stories/foxsyai/foxsyai-1.png',
  },
  {
    image: '/launchpad/stories/foxsyai/foxsyai-2.png',
  },
];

export const depositLimits = [
  {
    id: 'premium-plus',
    item: (
      <span className="font-normal">
        ✨ <span className="font-bold">Premium Plus –</span> Up to{' '}
        <span className="font-bold">250 SQRp</span>
      </span>
    ),
  },
  {
    id: 'premium',
    item: (
      <span className="font-normal">
        ✨ <span className="font-bold">Premium –</span> Up to{' '}
        <span className="font-bold">200 SQRp</span>
      </span>
    ),
  },
  {
    id: 'plus',
    item: (
      <span className="font-normal">
        ✨ <span className="font-bold">Plus –</span> Up to{' '}
        <span className="font-bold">150 SQRp</span>
      </span>
    ),
  },
  {
    id: 'free',
    item: (
      <span className="font-normal">
        ✨ <span className="font-bold">Free –</span> Up to{' '}
        <span className="font-bold">100 SQRp</span>
      </span>
    ),
  },
];

export const sqrActions = [
  {
    id: 'stake-sqr',
    item: (
      <>
        👉{' '}
        <ExternalLink
          href="https://magicsquare.io/staking"
          className="text-base-text-blue underline"
        >
          Stake $SQR Now
        </ExternalLink>
      </>
    ),
  },
  {
    id: 'learn-sqrp',
    item: (
      <>
        👉{' '}
        <ExternalLink
          href="https://docs.magicsquare.io/magic-launchpad/for-users/key-features#what-are-sqrp-points"
          className="text-base-text-blue underline"
        >
          Learn About SQRp
        </ExternalLink>
      </>
    ),
  },
];
